import React, { useState } from 'react';
import SupplierTable from './SupplierTable';
import SupplierForm from './SupplierForm';

const Suppliers = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      {showForm ? (
        <SupplierForm 
          onSuccess={() => setShowForm(false)}
          onCancel={() => setShowForm(false)}
        />
      ) : (
        <SupplierTable onAddSupplier={() => setShowForm(true)} />
      )}
    </>
  );
};

export default Suppliers;